import sortingStructureBySequence from './sortingStructureBySequence';

const processTextBody = (keyword, body) => {
    const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    sortingStructureBySequence(keyword);

    var bodyReplace = body.replace(/<p[^>]*>/g, '');
    bodyReplace = bodyReplace.replace(
        /<span style="color: rgb\(33, 33, 33\);">&nbsp;/g,
        '',
    );
    bodyReplace = bodyReplace.replace(/<span style="[^"]*">/g, '');
    bodyReplace = bodyReplace.replace(/<strong style="[^"]*">/g, '');
    bodyReplace = bodyReplace.replace(/<strong>/g, '');
    bodyReplace = bodyReplace.replace(/ <\/strong>/g, '');
    bodyReplace = bodyReplace.replace(/<\/strong>/g, '');
    bodyReplace = bodyReplace.replace(/<span style="color: black;">/g, '');
    bodyReplace = bodyReplace.replace(/<\/span>/g, '');
    bodyReplace = bodyReplace.replace(/<\/p>/g, '');
    bodyReplace = bodyReplace.replace(/<br\s*\/?>/g, '');
    bodyReplace = bodyReplace.replace(/&lt;/g, '<');
    bodyReplace = bodyReplace.replace(/&gt;/g, '>');
    bodyReplace = bodyReplace.replace(/&nbsp;/g, ' ');
    bodyReplace = bodyReplace.replace(
        new RegExp(escapeRegExp(keyword[0].name) + '\\s*:\\s*', 'i'),
        '',
    );

    var breakpoint = '';
    var no = 1;
    while (no < keyword.length) {
        if (no !== keyword.length - 1) {
            breakpoint += escapeRegExp(keyword[no].name) + '\\s*:\\s*|';
        } else {
            breakpoint += escapeRegExp(keyword[no].name) + '\\s*:\\s*';
        }

        no++;
    }

    breakpoint = new RegExp(breakpoint, 'i');
    bodyReplace = bodyReplace.split(breakpoint);

    const dataReturn = [];
    var obj;

    for (let a = 0; a < keyword.length; a++) {
        obj = {
            keyword: keyword[a].name + ':',
            text: bodyReplace[a] ? bodyReplace[a].trim() : '',
        };

        dataReturn.push(obj);
    }

    return dataReturn;
};

export default processTextBody;
